<div class="errwrap">
  <div class="errdiv1" id="errs"></div>
</div>
<div *ngIf="actionmode == 'Add' || actionmode == 'Edit'" class="searchdiv">
  <div class="card screen-wrapper">
    <div class="header headerdiv">
      <h1 class="screen-title">{{ screentitle }}</h1>

      <div class="button-wrapper bothbuttdiv2">
        <div *ngIf="actionmode == 'Add' || actionmode == 'Edit'" class="btn back-button button-margin ">
          <input type="button" [disabled]="RAC_APROVE!=1" class="btn btn-success commonbutt"
            style="width: 80px;font-weight: 700" value="Active" id="btnname" (click)="changeName()"
            *ngIf="isApproved && actionmode == 'Edit' && rejected!=2" />
          <button *ngIf="!viewpage" [disabled]="  
          " class="btn btn-success commonbutt" type="button" (click)="submitdata()">
            <em class="fa fa-check"></em>&nbsp;Submit
          </button>
          <button class="btn btn-danger commonbutt" (click)="searchForm()" type="button">
            <em class="fa fa-times"></em>&nbsp;Close
          </button>
        </div>
      </div>
    </div>

    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="form-div">
            <div class="row">
              <div class="m-portlet">
                <div>
                  <div>
                    <div>
                      <div [hidden]="!viewpage" class="tdive">
                        <table aria-describedby="ancillariesDetails" class="viewtable">
                          <div *ngFor="let q of viewPageDetails">

                            <tr>
                              <th scope="col">
                                <span class="vlbl">Ancillaries Type</span>
                              </th>
                              <td>
                                <span class="vVal">{{ q.TYPE }}</span>
                              </td>
                            </tr>

                            <tr>
                              <th scope="col">
                                <span class="vlbl">Ancillaries Description</span>
                              </th>
                              <td>

                                <span class="vVal">{{ q.DESCRIPTION }}</span>

                              </td>
                            </tr>

                          </div>


                        </table>
                      </div>
                      <div [hidden]="viewpage">

                        <div *ngIf="adLoader">
                          <div style="margin-left: 323px;text-align: center;position: absolute;z-index: 1;">
                            <img src="../../../../assets/img/Loading_Animation.gif" width="8%" height="8%" alt="Loader">

                          </div>
                        </div>
                        <div class="col-lg-12">
                          <div class="col-lg-3">
                            <label> Ancillaries Type</label>
                            <input [(ngModel)]="screen_details.TYPE" type="text" #code="ngModel"
                              (input)="checkLength($event.target.value)" (change)="gotochangestatus()"
                              (blur)="checkIt($event.target.value, 1)" class="form-control m-input"
                              placeholder="Enter Ancillaries Type" />
                          </div>
                        </div>
                        <div class="col-lg-12">
                          <div class="col-lg-6">
                            <label>Ancillaries Description</label>
                            <app-tiny-editor [elementId]="'my-editor1'" (onEditorContentChange)="keyupHandler1($event)"
                              [editedData]="editedData1">
                            </app-tiny-editor>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div *ngIf="actionmode != 'Add' && actionmode != 'Edit'" class="searchdiv">
  <div class="headerdiv">
    <h1>Ancillaries Description
    </h1>
    <div class="bothbuttdiv">
    </div>
  </div>

  <div class="card-body">
    <div class="row">
      <div class="col-md-12">
        <div class="form-div">
          <div>
            <div class="m-portlet">
              <div>
                <div>
                  <div class="wr15">
                    <div class="instruct">
                      <div class="int1" style="margin-left: 17px">
                        <span class="inst" style="font-size: 12px"><strong> Instructions </strong></span>
                        <br />
                        <span class="txt">
                          1. Please enter Ancillary Name
                        </span>
                        <br />
                        <span></span>
                      </div>
                    </div>
                    <div class="col-lg-3">
                      <label class="">Ancillaries Type</label>
                      <input [(ngModel)]="search_details.TYPE" class="form-control m-input"
                        placeholder="Enter Ancillaries Type" />
                    </div>

                    <div class="col-lg-3">
                      <button style="
                        width: 83px;
                        margin-top: 25px;" class="btn btn-primary commonbutt"
                        [disabled]="exceedLength1 || notAlphabet1" (click)="searchData()" type="button">
                        <em class="fa fa-search "></em>&nbsp;Search
                      </button>
                    </div>
                    <div class="clr"></div>
                  </div>
                </div>
              </div>


              <div class="clr"></div>


              <div *ngIf="adSearchresult" class="reportstatus" [hidden]="searchlist">
                <table aria-describedby="ancillariesSearchDetails" class="table table-striped" *ngIf="!adLoader"
                  [mfData]="adSearchtabledata" [mfRowsOnPage]="5">
                  <thead>
                    <tr>
                      <th scope="col" style="width: 20%" *ngIf="RAC_VIEW == '1' || RAC_EDIT == '1'">
                        Actions
                      </th>
                      <th scope="col" style="width: 20%">
                        <mfDefaultSorter by="TYPE">Ancillaries Type</mfDefaultSorter>
                      </th>
                      <th scope="col" style="width: 20%">
                        <mfDefaultSorter by="DESCRIPTION">Ancillaries Description
                        </mfDefaultSorter>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="
                        let item of (adSearchtabledata
                          | paginate: { itemsPerPage: 10, currentPage: p })
                      ">
                      <td *ngIf="RAC_VIEW == '1' || RAC_EDIT == '1'">
                        <button class="btn btn-default btn-circle" *ngIf="RAC_VIEW == '1'" type="button"
                          (click)="showFormData(item.AI_ID, 1)">
                          <em class="fa fa-eye"></em>
                        </button>
                        <span *ngIf="item.STATUS != '2' && item.PRE_APPROVE != '1'">
                          <button class="btn btn-default btn-circle" *ngIf="RAC_EDIT == '1'" type="button" (click)="
                              showFormData(
                                item.AI_ID,
                                2
                              )
                            ">
                            <em class="fa fa-pencil"></em>
                          </button>
                        </span>
                      </td>
                      <td>{{ item.TYPE | uppercase }}</td>
                      <td>{{ item.DESCRIPTION }}</td>

                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="5">
                        
                        <pagination-controls (pageChange)="p = $event"></pagination-controls>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
              <div *ngIf="adLoader">
                <div style="margin: 0 auto; text-align: center;">
                  <img src="../../../../assets/img/Loading_Animation.gif" width="8%" height="8%" alt="Loader">

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>